import React from 'react';
import PropTypes from 'prop-types';
import './TeamMemberCard.css';


const TeamMemberCard = (props) => {
  const { teamMember } = props;
  return (
    <div id="TeamMemberCard">
      <div id="profilePicture">
        <img
          src={teamMember.image}
          alt={teamMember.name}
          onError={(event) => {
            /* eslint-disable-next-line no-param-reassign */
            event.target.src = 'img/assets/team/place.jpg';
          }}
        />
      </div>

      <div id="textualInfo">
        <div id="title">
          <h1>{teamMember.name}</h1>
          <h2>{teamMember.position}</h2>
        </div>

        <div id="contact">
          <a
            href={`mailto:${teamMember.email}`}
          >
            {teamMember.email}
          </a>
          <a
            href={teamMember.lattes}
            target="_blank"
            rel="noopener noreferrer"
          >
            {teamMember.lattes}
          </a>
        </div>

        <div id="bio">
          <p>{teamMember.bio}</p>
        </div>
      </div>
    </div>
  );
};

TeamMemberCard.propTypes = {
  teamMember: PropTypes.shape({
    name: String.isRequired,
    position: String.isRequired,
    email: String.isRequired,
    lattes: String.isRequired,
    bio: String.isRequired,
    image: String.isRequired,
  }).isRequired,
};

export default TeamMemberCard;
